const mobileHeight = () => {
  let vh = window.innerHeight * 0.01;
  document.body.style.setProperty("--vh", `${vh}px`);
  window.addEventListener("orientationchange", function () {
    vh = window.innerHeight * 0.01;
    document.body.style.setProperty("--vh", `${vh}px`);
  });
};

export default mobileHeight;
